<template>
    <div class="terms-and-conditions__info">
        <i18n path="pam.registration.termsText">
            <StaticLink
                place="terms"
                :path="$WikiPath.TermsAndConditions"
                target="_blank"
                class="action-text"
            >{{ $capitalize($t('betting regulations').toString()) }}</StaticLink>
            <StaticLink
                place="statement"
                :path="$WikiPath.DataProtection"
                target="_blank"
                class="action-text"
            >{{ $t('Superbet Confidentiality Statement') }}</StaticLink>
            <StaticLink
                place="policy"
                :path="$WikiPath.PrivacyPolicy"
                target="_blank"
                class="action-text"
            >{{ $t('privacy policy') }}</StaticLink>
        </i18n>
    </div>
</template>

<script>
    import Vue from 'vue';

    import StaticLink from '@shared/components/StaticLink.vue';

    export default Vue.component('TermsAndConditions', {
        components: {
            StaticLink,
        },
    });
</script>
